module.exports = __webpack_public_path__ + "img/info-circle.70259a1d.svg";